module.exports = __webpack_public_path__ + "img/GY.fac76d52.png";